import Modal from "../../../components/Modal/Modal";

const DeleteModal = ({
  open,
  close,
  projectName,
  confirm,
  setConfirm,
  remove,
}) => (
  <Modal open={open} close={close}>
    <h2>Projeyi Sil</h2>
    <input
      className="modal-input"
      placeholder={`"${projectName}" yazın`}
      value={confirm}
      onChange={(e) => setConfirm(e.target.value)}
    />
    <div className="modal-buttons">
      <button
        className="modal-add-button"
        onClick={() => {
          if (confirm === projectName) {
            remove();
          }
        }}
      >
        Onayla ve Sil
      </button>
      <button className="modal-close-button" onClick={close}>
        İptal
      </button>
    </div>
  </Modal>
);
export default DeleteModal;
